module.exports = __webpack_public_path__ + "img/payment.5a0c8672.png";